const Header = () => {
  return (
    <header className="app-header">
      <div style={{ fontSize: "3rem" }}>🧠</div>
      <h1>Quiz Master</h1>
      <div style={{ fontSize: "3rem" }}>⚡</div>
    </header>
  );
};

export default Header;
